"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EAlertTypePriority;
(function (EAlertTypePriority) {
    EAlertTypePriority["LOW"] = "LOW";
    EAlertTypePriority["MEDIUM"] = "MEDIUM";
    EAlertTypePriority["HIGH"] = "HIGH";
})(EAlertTypePriority = exports.EAlertTypePriority || (exports.EAlertTypePriority = {}));
var EAlertType;
(function (EAlertType) {
    EAlertType["REJECTED_PAYMENTS"] = "REJECTED_PAYMENTS";
})(EAlertType = exports.EAlertType || (exports.EAlertType = {}));
var EAlertStatus;
(function (EAlertStatus) {
    EAlertStatus["NEW"] = "NEW";
    EAlertStatus["POSTPONED"] = "POSTPONED";
    EAlertStatus["IGNORED"] = "IGNORED";
    EAlertStatus["LOOKED_INTO"] = "LOOKED_INTO";
})(EAlertStatus = exports.EAlertStatus || (exports.EAlertStatus = {}));
var EUserAlertSettingsStatus;
(function (EUserAlertSettingsStatus) {
    EUserAlertSettingsStatus["DISABLED"] = "DISABLED";
    EUserAlertSettingsStatus["ENABLED"] = "ENABLED";
})(EUserAlertSettingsStatus = exports.EUserAlertSettingsStatus || (exports.EUserAlertSettingsStatus = {}));
var EAlertHistoryAction;
(function (EAlertHistoryAction) {
    EAlertHistoryAction["CREATED"] = "CREATED";
    EAlertHistoryAction["LOOKED_INTO"] = "LOOKED_INTO";
    EAlertHistoryAction["POSTPONED"] = "POSTPONED";
    EAlertHistoryAction["IGNORED"] = "IGNORED";
})(EAlertHistoryAction = exports.EAlertHistoryAction || (exports.EAlertHistoryAction = {}));
